import FindSurfaces from './libs/FindSurfaces.js';
import { CustomOutlinePass } from './libs/CustomOutlinePass.js';
import {getPointer} from './utils.js';
class RotiFooter extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        this.init();
    }
    init() {
        let initTl = gsap.timeline({
            scrollTrigger: {
                trigger: this.querySelector('.footer'),
                start: 'top bottom',
                onEnter: () => {
                    this.setup();
                },
                once: true
            }
        });
    }
    setup() {
        this.interact();
        this.interactMouseMove();
    }
    interactMouseMove() {
        const wrapHead = this.querySelector('.footer-head');
        const rotateMouseMove = (pointerX, pointerY, lerpVal) => { 
            let curPosX = gsap.getProperty(document.querySelector('.footer-head-canvas-inner'), 'x');
            let toPosX = pointerX * parseRem(40);
            let targetPosX = lerp(curPosX, toPosX, lerpVal);
            gsap.quickSetter(document.querySelector('.footer-head-canvas-inner'), 'x', 'px')(targetPosX);

            let curPosY = gsap.getProperty(document.querySelector('.footer-head-canvas-inner'), 'y');
            let toPosY = pointerY * parseRem(28);
            let targetPosY = lerp(curPosY, toPosY, lerpVal);
            gsap.quickSetter(document.querySelector('.footer-head-canvas-inner'), 'y', 'px')(targetPosY);
        }
        
        function update() {
            if (isInViewport(wrapHead)) {
                let targetX;
                let targetY;
                let lerpVal;
                if (document.querySelectorAll('.footer-head:hover').length) {
                    let wrapHeadRect = wrapHead.getBoundingClientRect();
                    targetX = gsap.utils.clamp(0, wrapHeadRect.width, getPointer().x - wrapHeadRect.left) / wrapHeadRect.width;
                    targetX = (targetX - 0.5) * 2;
                    targetY = gsap.utils.clamp(0, wrapHeadRect.height, getPointer().y - wrapHeadRect.top) / wrapHeadRect.height;
                    targetY = (targetY - 0.5) * 2;
                    lerpVal = 0.035;
                } else {
                    targetX = 0;
                    targetY = 0;
                    lerpVal = 0.05;
                }
                if (window.innerWidth > 991) {
                    rotateMouseMove(targetX, targetY, lerpVal)
                }
            }
            requestAnimationFrame(update);
        }
        update();
    }
    interact() {
        const btnToggleCurrency = this.querySelector('.footer-body-payment-currency-toggle'); 
        const listDropDown = this.querySelector('.footer-body-payment-currency-dropdown');
        const btnCurrencyText = btnToggleCurrency.querySelector('.txt'); 
        const listItems = listDropDown.querySelectorAll('.footer-body-payment-currency-dropdown-item');
        const popup = this.querySelector('.footer-body-popup-wrap');
        const form = this.querySelector('.selectors-form');

        btnToggleCurrency.addEventListener('click', () => {
            if (btnToggleCurrency.classList.contains('active')) {
                closeCurrency();
            } else {
                openCurrency();
            }
        });
        const openCurrency = () => {
            listDropDown.classList.add('active');
            btnToggleCurrency.classList.add('active');
            document.body.classList.add('on-dropdown-open')
        }
        const closeCurrency = () => {
            listDropDown.classList.remove('active');
            btnToggleCurrency.classList.remove('active');
            document.body.classList.remove('on-dropdown-open')
        }

        listItems.forEach((item, index) => {  
            const anchor = item.querySelector('a');
            const link = anchor.getAttribute('href');

            if(!link.includes('in.rotimatic')){

              if (item.getAttribute('iso-code') === btnCurrencyText.textContent) {
                  item.classList.add('active');
              }
              item.addEventListener('click', (e) => { 
                  e.preventDefault();
                  activeItem(listItems, index)
                  popup.classList.add('active');
                  btnCurrencyText.textContent = item.textContent;
                  fetch('/cart/clear.js').then(() => {
                    closeCurrency();
                  })
              })
            }
        })

        const popupClose = popup.querySelector('.footer-body-popup-close');
        popupClose.addEventListener('click', (e) => {
            e.preventDefault();
            popup.classList.remove('active');
            getLenis().start()
        })

        const btnCancel = popup.querySelector('.footer-body-popup-btn.btn-secondary');
        btnCancel.addEventListener('click', (e) => {
            e.preventDefault();
            popup.classList.remove('active');
            getLenis().start()
        })

        const btnContinue = popup.querySelector('.footer-body-popup-btn.btn-primary');
        btnContinue.addEventListener('click', (e) => {
            e.preventDefault();
            const inputCurrency = form.querySelector('[name="currency_code"]');
            const activeItem = Array.from(listItems).find(item => item.classList.contains('active'));
            inputCurrency.value = activeItem.getAttribute('iso-code');

            fetch('cart/clear').then(() => {
                popup.classList.remove('active');
                form.submit();
            });
        })

        document.addEventListener('click', (e) => {
            if (this.querySelectorAll('.footer-body-payment-currency-dropdown:hover').length >= 1 || this.querySelectorAll('.footer-body-payment-currency-toggle:hover').length >= 1) {
                return;
            } else {
                btnToggleCurrency.classList.remove('active');
                listDropDown.classList.remove('active');
            }
        })
    } 
    initThree() {
        this.path = this.getAttribute('data-glb');
        this.loader = new GLTFLoader();
        this.dracoLoader = new DRACOLoader();
        this.dracoLoader.setDecoderPath('https://www.gstatic.com/draco/v1/decoders/');
        this.loader.setDRACOLoader(this.dracoLoader);
        this.loader.load(this.path, () => {
            console.log('loaded')
        });
        this.myModel;
        const el = this.querySelector('.footer-head-canvas-main');
        const wrapHead = this.querySelector('.footer-head');
        const camera = new THREE.PerspectiveCamera(4, el.clientWidth / el.clientHeight, 0.1, 100);
        camera.position.set(0,0,6.8);
        camera.lookAt(0, -0.01, 0);
        
        const scene = new THREE.Scene();
        const renderer = new THREE.WebGLRenderer({alpha: true});

        renderer.setSize(el.clientWidth, el.clientHeight);
        renderer.domElement.style.position = 'absolute';
        el.appendChild(renderer.domElement);

        const depthTexture = new THREE.DepthTexture();
        const renderTarget = new THREE.WebGLRenderTarget(el.clientWidth * 2, el.clientHeight * 2, {
            depthTexture: depthTexture, 
            depthBuffer: true,
        });
        
        // Initial render pass.
        const composer = new EffectComposer(renderer, renderTarget);
        const pass = new RenderPass(scene, camera);
        composer.addPass(pass);

        // Outline pass.
        const customOutline = new CustomOutlinePass(
            new THREE.Vector2(el.clientWidth, el.clientHeight),
            scene,
            camera
        );
        composer.addPass(customOutline);

        // Antialias pass.
        const effectFXAA = new ShaderPass(FXAAShader);
        effectFXAA.uniforms["resolution"].value.set(
            1 / el.clientWidth * 1.5,
            1 / el.clientWidth * 1.5
        );
        composer.addPass(effectFXAA);
        
        const surfaceFinder = new FindSurfaces();

        this.loader.load(this.path, (gltf) => {
            let objs = gltf.scene;
            this.myModel = objs
            this.myModel.scale.set(0.5, 0.5, 0.5);

            scene.add(objs);
            surfaceFinder.surfaceId = 0;
            scene.traverse((node) => {
                if (node instanceof THREE.Mesh) {
                    const colorsTypedArray = surfaceFinder.getSurfaceIdAttribute(node);
                    node.geometry.setAttribute("color", new THREE.BufferAttribute(colorsTypedArray, 4));
                }
            });
            customOutline.updateMaxSurfaceId(surfaceFinder.surfaceId + 1);
            customOutline.renderScene.overrideMaterial = new THREE.MeshBasicMaterial({color: new THREE.Color(0x5E5E5E)});
        })
        const rotateMouseMove = (pointerX, pointerY, lerpVal) => { 
            if (this.myModel) {
                // let curRotY = this.myModel.rotation.y;
                // let toRotY = pointerX * Math.PI * .03;
                // let targetRotY = lerp(curRotY, toRotY, 0.05);
                // this.myModel.rotation.y = targetRotY;
                // let curRotX = this.myModel.rotation.x;
                // let toRotX = pointerY * Math.PI * .02;
                // let targetRotX = lerp(curRotX, toRotX, 0.05);
                // this.myModel.rotation.x = targetRotX;

                // let curPosX = this.myModel.position.x;
                // let toPosX = pointerX * 0.06;
                // let targetPosX = lerp(curPosX, toPosX, lerpVal);
                // this.myModel.position.x = targetPosX;
                // let curPosY = this.myModel.position.y;
                // let toPosY = pointerY * 0.02 * -1;
                // let targetPosY = lerp(curPosY, toPosY, lerpVal);
                // this.myModel.position.y = targetPosY;

                let curPosX = gsap.getProperty(document.querySelector('.footer-head-canvas-inner'), 'x');
                console.log(curPosX)
                let toPosX = pointerX * parseRem(40);
                let targetPosX = lerp(curPosX, toPosX, lerpVal);
                gsap.quickSetter(document.querySelector('.footer-head-canvas-inner'), 'x', 'px')(targetPosX);

                let curPosY = gsap.getProperty(document.querySelector('.footer-head-canvas-inner'), 'y');
                let toPosY = pointerY * parseRem(28);
                let targetPosY = lerp(curPosY, toPosY, lerpVal);
                gsap.quickSetter(document.querySelector('.footer-head-canvas-inner'), 'y', 'px')(targetPosY);

            }
        }
        
        function update() {
            if (isInViewport(el)) {
                composer.render();
                let targetX;
                let targetY;
                let lerpVal;
                if (document.querySelectorAll('.footer-head:hover').length) {
                    let wrapHeadRect = wrapHead.getBoundingClientRect();
                    targetX = gsap.utils.clamp(0, wrapHeadRect.width, getPointer().x - wrapHeadRect.left) / wrapHeadRect.width;
                    targetX = (targetX - 0.5) * 2;
                    targetY = gsap.utils.clamp(0, wrapHeadRect.height, getPointer().y - wrapHeadRect.top) / wrapHeadRect.height;
                    targetY = (targetY - 0.5) * 2;
                    lerpVal = 0.035;
                } else {
                    targetX = 0;
                    targetY = 0;
                    lerpVal = 0.05;
                }
                if (window.innerWidth > 991) {
                    rotateMouseMove(targetX, targetY, lerpVal)
                }
            }
            requestAnimationFrame(update);
        }
        update();

        function onWindowResize() {
            camera.aspect = el.clientWidth / el.clientHeight;
            camera.updateProjectionMatrix();
          
            renderer.setSize(el.clientWidth, el.clientHeight);
            composer.setSize(el.clientWidth * 2, el.clientHeight * 2);
            effectFXAA.setSize(el.clientWidth, el.clientHeight);
            customOutline.setSize(el.clientWidth * 2, el.clientHeight * 2);
            effectFXAA.uniforms["resolution"].value.set(
                1 / el.clientWidth * 2,
                1 / el.clientHeight * 2
            );
        }
        window.addEventListener("resize", onWindowResize, false);
    }
}
customElements.define('roti-footer', RotiFooter)